import type { InsightsType } from "@/redux/insights/insightTypes";

export const initialState: InsightsType = {
  fetching: false,
  success: null,
  error: null,
  statusCode: null,
  invoicingRevenueInsightsData: [],
  invoicingExpensesInsightsData: [],
};
